.container {
  display: flex;
  align-items: center;
  gap: 0.5rem 2rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

@media (max-width: 600px) {
  .container {
    gap: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
  }
}
